import { ILogger } from "@ezhou/common";
import { PageProps } from "@ezhou/core";

import { OrganizationChildCrudDataGrid } from "../common/OrganizationChildCrudDataGrid";

import {
  dummyRestfulApiScopeRow,
  restfulApiScopeColumns,
} from "./model/metaData";

export type RestfulApiScopesProps = {
  parentKey: any;
  pageProps: PageProps;
  logger: ILogger;
};

export const RestfulApiScopes = (props: RestfulApiScopesProps) => {
  const baseUrl = "restful-resources/scopes";
  const dataKey = "restfulApiScopeId";

  const dataToBeFiltered = ["restfulApiResource", "resourceName"];

  return (
    <>
      <div>Scopes</div>
      <OrganizationChildCrudDataGrid
        pageProps={props.pageProps}
        logger={props.logger}
        dummyRow={dummyRestfulApiScopeRow}
        keyExpr={dataKey}
        isKeyAutoGenerated={true}
        baseUrl={baseUrl}
        parentKey={props.parentKey}
        dataToBeFiltered={dataToBeFiltered}
        formTitle="Add Scope"
        formColCount={2}
        formColSpan={2}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        hideColumnChooser={true}
        hideSearchPanel={true}
        hideInactiveButton={true}
        columnConfigs={restfulApiScopeColumns}
      />
    </>
  );
};
